import React from "react";
import { ChevronRight, Inbox, RefreshCw } from "lucide-react";

import NativeAnnouncementDialog, {
  ANNOUNCEMENT_ICONS,
  ANNOUNCEMENT_LABELS,
} from "@/components/native/NativeAnnouncementDialog";
import { Skeleton } from "@/components/ui/skeleton";
import { useSystemAnnouncements } from "@/queries/system";

export default function AnnouncementsPage() {
  const [selectedAnnouncement, setSelectedAnnouncement] = React.useState(null);
  const {
    announcements,
    isLoading,
    isError,
    refetch,
  } = useSystemAnnouncements({ refetchOnMount: true });

  return (
    <div className="native-v3-account-announcements space-y-4">
      <header className="native-v3-account-announcements-intro">
        <span>Information</span>
        <h2>Meddelanden från Lapstr</h2>
        <p>Aktuell information, nyheter och viktiga driftmeddelanden samlade på ett ställe.</p>
      </header>

      {isLoading ? (
        <div className="native-v3-account-announcement-list" aria-label="Laddar meddelanden">
          {[0, 1, 2].map((item) => (
            <Skeleton key={item} className="native-v3-account-announcement-skeleton" />
          ))}
        </div>
      ) : isError ? (
        <div className="native-v3-account-announcement-empty" role="alert">
          <Inbox aria-hidden="true" />
          <strong>Kunde inte hämta meddelanden</strong>
          <p>Kontrollera anslutningen och försök igen.</p>
          <button type="button" onClick={() => refetch()}>
            <RefreshCw aria-hidden="true" /> Försök igen
          </button>
        </div>
      ) : announcements.length ? (
        <div className="native-v3-account-announcement-list">
          {announcements.map((announcement) => {
            const level = ANNOUNCEMENT_ICONS[announcement?.level] ? announcement.level : "info";
            const Icon = ANNOUNCEMENT_ICONS[level];
            const title = String(announcement?.title || "").trim() || "Meddelande";
            return (
              <button
                type="button"
                className="native-v3-account-announcement-row"
                data-level={level}
                key={`${announcement?.id || title}:${announcement?.version || 0}`}
                onClick={() => setSelectedAnnouncement(announcement)}
              >
                <span className="native-v3-account-announcement-icon" aria-hidden="true"><Icon /></span>
                <span className="native-v3-account-announcement-copy">
                  <small>{ANNOUNCEMENT_LABELS[level]}</small>
                  <strong>{title}</strong>
                </span>
                <ChevronRight aria-hidden="true" />
              </button>
            );
          })}
        </div>
      ) : (
        <div className="native-v3-account-announcement-empty">
          <Inbox aria-hidden="true" />
          <strong>Inga aktuella meddelanden</strong>
          <p>Det finns inga aktuella meddelanden från Lapstr.</p>
        </div>
      )}

      <NativeAnnouncementDialog
        announcement={selectedAnnouncement}
        open={Boolean(selectedAnnouncement)}
        onOpenChange={(open) => {
          if (!open) setSelectedAnnouncement(null);
        }}
      />
    </div>
  );
}
